import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'

import { ConfigKey } from 'containers/forms/configuration'
import { Section } from 'components/layout'
import { apiConfiguration } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS } from 'constants/enums'
import ConfigLoader from 'components/loaders/ConfigLoader/ConfigLoader'

const documentConfigKeys = [
  CONFIGURATION_KEYS.assessorConduct.id,
  CONFIGURATION_KEYS.assessorRole.id,
  CONFIGURATION_KEYS.assessorKeyConditionRequirements.id,
  CONFIGURATION_KEYS.assessorReferenceHandbook.id,
  CONFIGURATION_KEYS.assessorReferenceOnline.id
]

const enhance = compose(
  apiConfiguration({
    getValues: documentConfigKeys
  })
)

class ConfigurationAssessor extends Component {
  static propTypes = {
    changeConfig: PropTypes.func.isRequired,
    configuration: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    isSameLevel: PropTypes.bool,
    editCustomizationEnabled: PropTypes.bool.isRequired
  }

  render() {
    const { configuration, activeOrganization, isSameLevel, route, editCustomizationEnabled } = this.props

    let sectionItems = []

    documentConfigKeys.forEach(key => {
      if (configuration.values[key]) {
        sectionItems = sectionItems.concat(configuration.values[key])
      }
    })

    const loading = configuration.loading

    return (
      <Section
        loading={loading}
        contentLoader={<ConfigLoader withTabs={false} />}
      >
        {sectionItems.length === 0 &&
          <FormattedMessage
            id="label.no_config_key_available"
            defaultMessage="No configuration keys available for this section"
          />}

        {sectionItems.map(conf => (
          <ConfigKey
            key={conf.id}
            config={conf}
            onConfigEdit={this.props.changeConfig}
            activeOrganization={activeOrganization}
            standalone={false}
            isSameLevel={isSameLevel}
            options={{
              isIc: get(route, 'isIc'),
              isTypeId: get(route, 'isTypeId')
            }}
            editCustomizationEnabled={editCustomizationEnabled}
          />
        ))}
      </Section>
    )
  }
}

export default enhance(ConfigurationAssessor)
